import Vue from 'vue'
import Buntpapier from 'buntpapier'
import Vuelidate from 'vuelidate'
import store from 'store'
import router from 'router'

import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import 'styles/main.styl'

Vue.config.productionTip = false
Vue.use(Buntpapier)
Vue.use(Vuelidate)
store.dispatch('init')

new Vue({
	store,
	router,
	render: h => h('router-view'),
}).$mount('#app')


window.store = store
